import { FieldKeyValueModel } from "./field-key-value-model";

export enum DataType {
    DateTime = 1,
    //
    // Summary:
    //     Represents a date value.
    Date = 2,
    //
    // Summary:
    //     Represents a time value.
    Time = 3,
    //
    // Summary:
    //     Represents a continuous time during which an object exists.
    Duration = 4,
    //
    // Summary:
    //     Represents a phone number value.
    PhoneNumber = 5,
    //
    // Summary:
    //     Represents a currency value.
    Currency = 6,
    //
    // Summary:
    //     Represents text that is displayed.
    Text = 7,
    //
    // Summary:
    //     Represents an HTML file.
    Html = 8,
    //
    // Summary:
    //     Represents multi-line text.
    MultilineText = 9,
    //
    // Summary:
    //     Represents an email address.
    EmailAddress = 10,
    //
    // Summary:
    //     Represent a password value.
    Password = 11,
    //
    // Summary:
    //     Represents a URL value.
    Url = 12,
    //
    // Summary:
    //     Represents a URL to an image.
    ImageUrl = 13,
    //
    // Summary:
    //     Represents a credit card number.
    CreditCard = 14,
    //
    // Summary:
    //     Represents a postal code.
    PostalCode = 15,
    //
    // Summary:
    //     Represents file upload data type.
    Upload = 16,
    Boolean = 17,
    Decimal = 18,
    DropDown = 19,
    MultiSelectDropDown = 20,
    CommaSeparated = 21,
    Integer = 22,
}

export class CustomFieldBaseModel {
    name?: string;
    value?: any;
    valueInverse?: string;
    dataType?: DataType;
    keyValues: FieldKeyValueModel<string, string>[] | null = [];
    isVisible?: boolean;
    isReadOnly?: boolean;
}
